import * as z from "zod/v4";

export const deleteMetaAdsIntegration = {
  name: "deleteMetaAdsIntegration" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
